<template>
  <div style="width:100%;height:580px;background-color: #083078;position:relative;">
    <div class="container-info">
      <div class="title-container">
        <h1 class="title">Quality & Care</h1>
        <h2 class="subtitle">{{ $t("messages.mensajeJumboMain") }}</h2>
      </div>
      <a href="#testimoniales" class="boton-contactanos">
        {{ $t("messages.submensajeJumboMain") }}
      </a>
    </div>

    <!-- Using the slider component -->
    <slider ref="slider" :options="options">
      <!-- slideritem wrapped package with the components you need -->
      <slideritem v-for="(item, index) in images" :key="index">
        <img :src="item" class="image-slider" alt="imagen de quality care" />
      </slideritem>
    </slider>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  components: {
    slider,
    slideritem
  },
  data() {
    return {
      translateValue: 0,
      currentIndex: 0,
      images: [
        '../../assets/layout/images/foto1.jpg',
        '../../assets/layout/images/foto2.jpg',
        '../../assets/layout/images/foto3.jpg',
        '../../assets/layout/images/foto4.jpg',
        '../../assets/layout/images/foto5.jpg',
        '../../assets/layout/images/foto6.jpg',
        '../../assets/layout/images/foto7.jpg',
        '../../assets/layout/images/foto8.jpg',
        '../../assets/layout/images/foto9.jpg',
        '../../assets/layout/images/foto10.jpg',
      ],
      //Slider configuration [obj]
      options: {
        currentPage: 0,
        autoplay: '4000',
        loop: true,
        effect: 'fade',
        speed: 1000
      }
    };
  },
  computed: {
    widthScreen() {
      return window.innerWidth;
    }
  },
}
</script>

<style scoped>
.slider {
  width: 100%;
  overflow: hidden;
}

.slides {
  display: flex;
  transition: transform 0.5s ease;
}

.slide {
  flex: 0 0 50%;
  /* Cada slide ocupa la mitad del contenedor */
}

.image-slider {
  width: 100%;
  height: auto;
}


.container-info {
  position: absolute;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  z-index: 99;
  width: fit-content;
  bottom: 30px;
  left: 30px;
  max-width: 450px;
}

.title-container {
  display: flex;
  flex-direction: column;
  background-color: #041A42;
  color: #ffffff;
  width: 100%;
  padding: 30px;
}

.title {
  margin: 0px;
  font-size: 30px;
}

.subtitle {
  margin: 0px;
  padding-top: 10px;
  font-size: 18px;
  line-height: 26px;
}

.boton-contactanos {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 41px;
  background-color: #2B86D9;
  color: #ffffff;
  font-size: 14px;
  line-height: 21px;
  border-radius: 9999px;
  margin-top: 30px;
  cursor: pointer;
}

@media screen and (max-width: 1142px) {
  .image-slider {
    width: auto;
    height: 100%;
  }
}

@media screen and (max-width: 480px) {
  .container-info {
    left: 0px;
    width: 100%;
    max-width: none;
  }
}
</style>